import styled from 'styled-components';
import { COLORS } from '@ertelecom/ui-react/assets/js/constants';

export const FormContainer = styled.div`
    width: 100%;
    display:flex;
    flex-wrap: nowrap;
    padding: 50px 60px;
    background: ${COLORS.white};
    border: 1px solid ${COLORS.outlineGrey};
    box-sizing: border-box;
    border-radius: 4px;
    margin-bottom: 40px;
    @media (max-width: 1600px) {
        padding: 40px 60px;
    }
    @media (max-width: 1300px) {
        padding: 30px;
    }
    @media (max-width: 1000px) {
        flex-direction: column;
    }
    @media (max-width: 700px) {
        padding: 20px;
    }
`;
export const FormText = styled.div`
    border-right: 1px solid ${COLORS.grey};
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    width: 50%;    
    padding-right: 4%;
    @media (max-width: 1300px) {
        width: 30%;
    }
    @media (max-width: 1000px) {
        width: 100%;
        padding-right: 0;
        border-right: 0;
        margin-bottom: 30px;
    }
`;
export const FormTitle = styled.div`
    font-size: 24px;
    line-height: 32px;
    margin-bottom: 10px;    
    width: 100%;
    @media (max-width: 1500px) {
        font-size: 20px;
        line-height: 28px;
    }
`;
export const FormDesc = styled.div`
    font-size: 16px;
    line-height: 24px;
    color: ${COLORS.darkGrey};
    width: 100%;
    @media (max-width: 1100px) {
        font-size: 14px;
        line-height: 18px;
    }
    @media (max-width: 800px) {
        font-size: 16px;
        line-height: 24px;
    }
`;
export const FormRight = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 50%;
    padding-left: 8%;
    @media (max-width: 1600px) {
        padding-left: 4%;
    }
    @media (max-width: 1300px) {
        width: 70%;
    }
    @media (max-width: 1000px) {
        width: 100%;
        padding-left: 0;
        justify-content: flex-start;
    }
`;
